import { render } from "./CohortDetail.vue?vue&type=template&id=d599b3f6"
import script from "./CohortDetail.vue?vue&type=script&lang=js"
export * from "./CohortDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__